export const getPageTitle = (path) => {
    let title;
    let loweredPath = path.toLowerCase();
    switch(loweredPath){
        case '/my-tasks': title = 'My Cases'; break;
        default: title = '';
    }
    if(title === ''){
        if(loweredPath.startsWith('/my-tasks/taskdetails')) title = 'Case Details';
    }
    return title;
}